import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <span className="text-2xl font-bold bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
              PeauGlow
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className="text-gray-700 hover:text-pink-500 transition-colors font-medium"
            >
              Accueil
            </Link>
            <Link 
              to="/boutique" 
              className="text-gray-700 hover:text-pink-500 transition-colors font-medium"
            >
              Boutique
            </Link>
            <Link 
              to="/soins-esthetiques" 
              className="text-gray-700 hover:text-pink-500 transition-colors font-medium"
            >
              Soins Esthétiques
            </Link>
            <a 
              href="#contact" 
              className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-6 py-2 rounded-full hover:shadow-lg transition-all"
            >
              Contact
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Menu"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-4 py-4 space-y-3">
            <Link 
              to="/" 
              className="block text-gray-700 hover:text-pink-500 transition-colors font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Accueil
            </Link>
            <Link 
              to="/boutique" 
              className="block text-gray-700 hover:text-pink-500 transition-colors font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Boutique
            </Link>
            <Link 
              to="/soins-esthetiques" 
              className="block text-gray-700 hover:text-pink-500 transition-colors font-medium py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Soins Esthétiques
            </Link>
            <a 
              href="#contact" 
              className="block bg-gradient-to-r from-pink-500 to-purple-600 text-white px-6 py-2 rounded-full text-center hover:shadow-lg transition-all"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
